import { MultipartFormData } from './multipart';

export class LightMultipartFormData extends MultipartFormData<Record<string, string>> {

  build(): FormData {
    const formData = new FormData();

    formData.append('files', this.file);
    if (this.option != null) {
      for (const key in Object.keys(this.option)) {
        formData.append(key, this.option[key]);
      }
    }

    return formData;
  }

}
